import { ArrowBack } from '@mui/icons-material';
import { BackButton, StyledPageLayoutHeader, StyledPageLayoutHeaderActions, Title } from './styles';
import { useTheme } from '@mui/material/styles';
import { ReactNode } from 'react';
import { MaxContent } from '@/styles/globalStyles';
import { Box, useMediaQuery } from '@mui/material';
import { SafeMarkdown } from '@/components/atoms/markdown/safe';

/**
 * @deprecated This component is deprecated. Use the unified header system through
 * PrivateRoute.headerConfig instead. This component will be removed in a future version.
 */
interface PageLayoutHeaderProps {
  onBack?: () => void;
  title: string;
  children?: ReactNode;
  hasBaseMargin?: boolean;
}

interface CustomContentProps {
  children: ReactNode;
}

/**
 * @deprecated This component is deprecated. Use the unified header system through
 * PrivateRoute.headerConfig instead. This component will be removed in a future version.
 */
export const PageLayoutHeader = ({
  onBack,
  title,
  children,
  hasBaseMargin = false,
}: PageLayoutHeaderProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const iconColor = theme.palette.text.primary;

  const CustomContent = ({ children }: CustomContentProps) => {
    if (hasBaseMargin) {
      return <Box sx={{ margin: theme.spacing(0, 3) }}>{children}</Box>;
    }

    return <MaxContent>{children}</MaxContent>;
  };

  return (
    <CustomContent>
      <StyledPageLayoutHeader>
        <StyledPageLayoutHeaderActions>
          {onBack && (
            <BackButton onClick={onBack}>
              <ArrowBack sx={{ color: iconColor }} />
            </BackButton>
          )}

          <Title variant={isMobile ? 'h6' : 'h4'}>
            <SafeMarkdown text={title} />
          </Title>
        </StyledPageLayoutHeaderActions>

        {children}
      </StyledPageLayoutHeader>
    </CustomContent>
  );
};
